import { Container, Grid } from "@mui/material";
import styled from "@emotion/styled";
import {Typography} from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';


const FaqContainer = styled(Container)`
    padding-top: 50px;
    padding-bottom: 50px;
    background-color: #000024;
    @media (max-width: 749px){
        padding-top: 20px;
        padding-bottom: 20px;
    }
`
const Heading = styled(Typography)`
    color:#fff;
    font-size:50px;
    font-family: poppins-b;
    text-align: center;
    margin-bottom:30px;
    @media (max-width: 749px){
        font-size:30px;
        margin-bottom:20px;
    }
`
const AccordianHeading = styled(Typography)`
    font-family:poppins-b;
    font-size:13px;
    color:#fff;
    @media(max-width: 749px){
        font-size:10px;
    }
`
const Accordiandesc =styled(Typography)`
    font-family:poppins;
    font-size:13px;
    color:#fff;
    background:transparent;
`
const AccordionWrapper = styled(Accordion)`
    background-color:#01014D;
    padding-top:14px;
    padding-bottom:13px;
    padding-left:20px;
    border-radius: 10px;
    margin-bottom: 10px;
    svg{
        color:#fff;
        size:18px;
    }
    @media (max-width:749px){   
        padding-top:10px;
        padding-bottom:8px;
        padding-left:10px;
    }
`
const Faq = () => {
    return(
        <FaqContainer maxWidth="xxl" id="faq">
    `        <Container maxWidth="xl" sx={{padding:'0px'}}>
                <Grid container>
                    <Grid item xs={12}>
                            <Heading variant="h1" data-aos="zoom-in" >FAQ</Heading>
                    <AccordionWrapper >
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                        >
                        <AccordianHeading>How does Pulse Mixer ensure the privacy of transactions?</AccordianHeading>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Accordiandesc>
                        Pulse Mixer employs advanced zero-knowledge protocols that obfuscate the origins and destinations
                         of transactions. This makes it extremely difficult to trace and identify the parties involved. Our
                          cutting-edge mixing algorithm combines funds from multiple users,
                         ensuring that the mixed coins are detached from their original sources,
                          providing enhanced privacy and confidentiality.
                        </Accordiandesc>
                        </AccordionDetails>
                    </AccordionWrapper>
                    <AccordionWrapper >
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                        >
                        <AccordianHeading>Are there any fees associated with using Pulse Mixer?</AccordianHeading>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Accordiandesc>
                        Yes, there are fees associated with using Pulse Mixer. However, we strive to provide cost-effective
                         privacy protection. Our fee structure is competitive and designed to ensure that users can enjoy 
                         the benefits of enhanced privacy without breaking the bank.
                         Users are charged a flat 5% of their transaction amount when mixing their deposited funds.
                        </Accordiandesc>
                        </AccordionDetails>
                    </AccordionWrapper>
                    <AccordionWrapper >
                        <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2a-content"
                        id="panel2a-header"
                        >
                        <AccordianHeading>Is Pulse Mixer compatible with other wallets and platforms?</AccordianHeading>
                        </AccordionSummary>
                        <AccordionDetails>
                        <Accordiandesc>
                        Pulse Mixer seamlessly integrates with the Pulse network, allowing users to leverage our privacy-enhancing
                         features within the ecosystem. We are compatible with various wallets that support the Pulse network, ensuring 
                         that you can easily integrate and utilize our mixer. As long as
                         your wallet is compatible with the Pulse network, you can enjoy the benefits of Pulse Mixer's privacy protection.
                        </Accordiandesc>
                        </AccordionDetails>
                    </AccordionWrapper>
                    </Grid>
                </Grid>`
            </Container>
        </FaqContainer>
    );
}

export default Faq;